<div id="splitViewer">    
    <div id="slider">
        <div id="sliderHandle">
            <fa-icon icon="arrows-h" size="2x" class="fdm-icon"></fa-icon>
        </div>
    </div>
    <div id="sliderContent">
        <div id="splitViewToolbar">
            <div id="svToolbarLeft">
                <mat-form-field appearance="standard" floatLabel="always" style="font-size: small;">
                    <mat-label>Left Side</mat-label>
                    <mat-select [(ngModel)]="leftSideId" (ngModelChange)="updateLeftSide($event)">
                        <ng-container *ngFor="let aa of allLabels">
                            <mat-option *ngIf="aa.id !== rightSideId" [value]="aa.id">{{ aa.label }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div id="svToolbarToggles">
                <mat-button-toggle-group name="dimensions" [(ngModel)]="dimensionSelection" (ngModelChange)="updateLayerChoices($event)" style="font-size: small; border-radius: 0;">
                    <mat-button-toggle value="2d">2D Only</mat-button-toggle>
                    <mat-button-toggle value="3d">3D Only</mat-button-toggle>
                    <mat-button-toggle value="all">All Layers</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div id="svToolbarRight">
                <mat-form-field appearance="standard" floatLabel="always" style="font-size: small;">
                    <mat-label>Right Side</mat-label>
                    <mat-select [(ngModel)]="rightSideId" (ngModelChange)="updateRightSide($event)">
                        <ng-container *ngFor="let aa of allLabels">
                            <mat-option *ngIf="aa.id !== leftSideId" [value]="aa.id">{{ aa.label }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
